function getDay (date) {
  if (!date) {
    return ''
  }
  let nowTime = new Date().getTime()
  let oldTime = new Date(date).getTime()

  let sub = nowTime - oldTime
  if (sub < 0) {
    return after(sub)
  }
  if (sub === 0) {
    return '刚刚'
  }
  if (sub > 0) {
    return before(sub)
  }
}

function before (sub) {
  if (sub < 1000 * 60) {
    let time = Math.floor(sub / 1000)
    return time + '秒前'
  }

  if (1000 * 60 <= sub && sub < 1000 * 60 * 60) {
    return Math.floor(sub / (1000 * 60)) + '分钟前'
  }

  if (1000 * 60 * 60 <= sub && sub < 1000 * 60 * 60 * 24) {
    return Math.floor(sub / (1000 * 60 * 60)) + '小时前'
  }

  if (1000 * 60 * 60 * 24 <= sub && sub < 1000 * 60 * 60 * 24 * 7) {
    return Math.floor(sub / (1000 * 60 * 60 * 24)) + '天前'
  }

  if (1000 * 60 * 60 * 24 * 7 <= sub && sub < 1000 * 60 * 60 * 24 * 30) {
    return Math.floor(sub / (1000 * 60 * 60 * 24 * 7)) + '星期前'
  }

  if (1000 * 60 * 60 * 24 * 30 <= sub && sub < 1000 * 60 * 60 * 24 * 365) {
    return Math.floor(sub / (1000 * 60 * 60 * 24 * 30)) + '月前'
  }

  if (1000 * 60 * 60 * 24 * 365 <= sub) {
    return Math.floor(sub / (1000 * 60 * 60 * 24 * 365)) + '年前'
  }
}

function after (sub) {
  sub = Math.abs(sub)
  if (sub < 1000 * 60) {
    let time = Math.floor(sub / 1000)
    return time + '秒后'
  }

  if (1000 * 60 <= sub && sub < 1000 * 60 * 60) {
    return Math.floor(sub / (1000 * 60)) + '分钟后'
  }

  if (1000 * 60 * 60 <= sub && sub < 1000 * 60 * 60 * 24) {
    return Math.floor(sub / (1000 * 60 * 60)) + '小时后'
  }

  if (1000 * 60 * 60 * 24 <= sub && sub < 1000 * 60 * 60 * 24 * 7) {
    return Math.floor(sub / (1000 * 60 * 60 * 24)) + '天后'
  }

  if (1000 * 60 * 60 * 24 * 7 <= sub && sub < 1000 * 60 * 60 * 24 * 30) {
    return Math.floor(sub / (1000 * 60 * 60 * 24 * 7)) + '星期后'
  }

  if (1000 * 60 * 60 * 24 * 30 <= sub && sub < 1000 * 60 * 60 * 24 * 365) {
    return Math.floor(sub / (1000 * 60 * 60 * 24 * 30)) + '月后'
  }

  if (1000 * 60 * 60 * 24 * 365 <= sub) {
    return Math.floor(sub / (1000 * 60 * 60 * 24 * 365)) + '年后'
  }
}

export default getDay



// WEBPACK FOOTER //
// ./src/utils/getDay.js